import { render, staticRenderFns } from "./CellosignIframe.vue?vue&type=template&id=37a989bf&scoped=true"
import script from "./CellosignIframe.vue?vue&type=script&lang=js"
export * from "./CellosignIframe.vue?vue&type=script&lang=js"
import style0 from "./CellosignIframe.vue?vue&type=style&index=0&id=37a989bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a989bf",
  null
  
)

export default component.exports